export default __webpack_public_path__ + "static/media/POLÍTICA DE PRIVACIDADE (no webite).8bb305c3.docx";